<template>
  <div>
    <div class="ml-l pl-l mb-l pb-l">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>
    <el-form class="marketing-type-form" label-position="left" label-width="100px" ref="form" size="small">
      <div class="container">
        <h3 class="title">新建营销规则</h3>

        <el-form-item label="营销规则名称" prop="name">
          <el-col span="8">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="营销类型" prop="kind">
          <el-row>
            <el-col span="2">
              <el-radio :label="1" v-model="form.kind">订单满减</el-radio>
            </el-col>
            <template v-if="form.kind == 1">
              <el-col span="1" style="text-align:center;">满</el-col>
              <el-col span="2">
                <el-input v-model="form.reach">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-col>
              <el-col span="1" style="text-align:center;">减</el-col>
              <el-col span="2">
                <el-input v-model="form.reduction">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-col>
            </template>
          </el-row>
          <el-row>
            <el-col span="2">
              <el-radio :label="20" v-model="form.kind">满赠优惠券</el-radio>
            </el-col>
            <template v-if="form.kind == 20">
              <el-col span="1" style="text-align:center;">满</el-col>
              <el-col span="2">
                <el-input v-model="form.reach">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-col>
              <el-col span="1" style="text-align:center;">赠</el-col>
              <el-col span="2">
                <el-button @click="dialogTableVisible = true" size="small">
                  {{ currentGift.name || '选择优惠券模版' }}
                  <i class="el-icon-arrow-right el-icon--right"></i>
                </el-button>
              </el-col>
            </template>
          </el-row>
          <el-row>
            <el-col span="2">
              <el-radio :label="21" v-model="form.kind">满赠商品</el-radio>
            </el-col>
            <template v-if="form.kind == 21">
              <el-col span="1" style="text-align:center;">满</el-col>
              <el-col span="2">
                <el-input v-model="form.reach">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-col>
              <el-col span="1" style="text-align:center;">赠</el-col>
              <el-col class="product-select" span="4">
                <el-select remote filterable :loading="fetchProductLoading" :remote-method="getProducts" placeholder="搜索商品" v-model="currentGift.id" style="width: 100%;">
                  <el-option :key="product.id" :label="product.name" :value="product.id" v-for="product in products"></el-option>
                </el-select>
              </el-col>
            </template>
          </el-row>
          <el-row>
            <el-col span="3">
              <el-radio :label="0" v-model="form.kind">用户手动领券</el-radio>
            </el-col>
            <el-col span="3" v-show="form.kind == 0">
              <el-button @click="dialogTableVisible = true" size="small">
                {{ currentGift.name || '选择优惠券模版' }}
                <i class="el-icon-arrow-right el-icon--right"></i>
              </el-button>
            </el-col>
            <el-col offset="1" span="6" v-show="form.kind == 0">
              <el-switch style="margin-top: -3px;" v-model="form.newuser" :inactive-value="0" :active-value="1" />
              <span style="margin-left: 10px;">仅限新用户</span>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="有效时间">
          <el-row>
            <el-col span="2">
              <el-radio label="0" v-model="limittime">不限制</el-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="2">
              <el-radio label="1" v-model="limittime">固定时段</el-radio>
            </el-col>
            <el-col span="4" v-show="limittime == 1">
              <el-date-picker :picker-options="pickerOptions" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" v-model="time"></el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="适用商品" v-if="form.kind == 1 || form.kind == 20 || form.kind == 21 || form.kind == 3">
          <el-row>
            <el-col span="4">
              <el-radio :label="0" v-model="form.producttype">作用于所有商品</el-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="4">
              <el-radio :label="1" v-model="form.producttype">作用于部分商品</el-radio>
            </el-col>
            <template v-if="form.producttype == 1">
              <el-col class="product-select" span="4">
                <el-select :loading="fetchProductLoading" :remote-method="getProducts" filterable multiple placeholder="搜索商品" remote v-model="form.productidsList" style="width: 100%;">
                  <el-option :key="product.id" :label="product.name" :value="product.id" v-for="product in products"></el-option>
                </el-select>
              </el-col>
            </template>
          </el-row>
          <el-row>
            <el-col span="4">
              <el-radio :label="2" v-model="form.producttype">不作用于部分商品</el-radio>
            </el-col>
            <template v-if="form.producttype == '2'">
              <el-col span="4">
                <el-select :loading="fetchProductLoading" :remote-method="getProducts" filterable multiple placeholder="搜索商品" remote v-model="form.productidsList">
                  <el-option :key="product.id" :label="product.name" :value="product.id" v-for="product in products"></el-option>
                </el-select>
              </el-col>
            </template>
          </el-row>
        </el-form-item>

        <el-form-item label="展示商品" v-if="form.kind == 0 && form.newuser == 0">
          <el-row>
            <el-col span="4">
              <el-radio :label="0" v-model="form.producttype">展示于所有商品页</el-radio>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="4">
              <el-radio :label="1" v-model="form.producttype">展示于部分商品页</el-radio>
            </el-col>
            <template v-if="form.producttype == 1">
              <el-col class="product-select" span="4">
                <el-select :loading="fetchProductLoading" :remote-method="getProducts" filterable multiple placeholder="搜索商品" remote v-model="form.productidsList" style="width: 100%;">
                  <el-option :key="product.id" :label="product.name" :value="product.id" v-for="product in products"></el-option>
                </el-select>
              </el-col>
            </template>
          </el-row>
          <el-row>
            <el-col span="4">
              <el-radio :label="2" v-model="form.producttype">不展示于部分商品页</el-radio>
            </el-col>
            <template v-if="form.producttype == '2'">
              <el-col span="4">
                <el-select :loading="fetchProductLoading" :remote-method="getProducts" filterable multiple placeholder="搜索商品" remote v-model="form.productidsList">
                  <el-option :key="product.id" :label="product.name" :value="product.id" v-for="product in products"></el-option>
                </el-select>
              </el-col>
            </template>
          </el-row>
        </el-form-item>
      </div>
    </el-form>

    <div class="container conponedit-button">
      <el-button @click="onSubmit" type="primary">创建</el-button>
    </div>

    <el-dialog :visible.sync="dialogTableVisible" title="优惠券模版" width="1000px">
      <el-table :data="coupontemplatelist" border row-key="id">
        <el-table-column label="券名称" prop="name" />
        <el-table-column label="面值">
          <template slot-scope="scope">
            <div v-if="scope.row.amountkind == 0">{{ `${scope.row.amountbegin / 100}元 ~ ${scope.row.amountend / 100}元` }}</div>
            <div v-else>{{ scope.row.amount / 100 }}元</div>
          </template>
        </el-table-column>
        <el-table-column label="规则" prop="rule">
          <template slot-scope="scope">
            <div>满{{ scope.row.reach / 100 }}可用</div>
          </template>
        </el-table-column>
        <el-table-column label="有效期">
          <template slot-scope="scope">
            <div v-if="scope.row.timekind === 0">不限制</div>
            <div v-if="scope.row.timekind === 2">发放或领取后{{ scope.row.duration / 60 / 60 / 24 }}天</div>
          </template>
        </el-table-column>
        <el-table-column label="生效范围">
          <template slot-scope="scope">
            <div v-if="scope.row.producttype === 0">可用于所有商品</div>
            <div v-if="scope.row.producttype === 1">可用于部分商品</div>
            <div v-if="scope.row.producttype === 2">不可用于部分商品</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="chooseCoupon(scope.row)" size="small" type="text">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc, rpc1 } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';
const pickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }
  ]
};

export default {
  data() {
    return {
      products: [],
      pickerOptions,
      coupontemplatelist: [],
      dialogTableVisible: false,
      form: {
        name: '',
        kind: 1,
        newuser: 0,
        reach: 0,
        reduction: 0,
        gifttype: 0,
        giftid: 0,
        producttype: 0,
        productidsList: [],
        categorytype: 0,
        categoryidsList: []
      },
      limittime: '0',
      time: [],
      currentGift: {},
      fetchProductLoading: false,
      token: ''
    };
  },
  watch: {
    'form.kind': {
      handler() {
        this.currentGift = {};
      }
    }
  },
  created() {
    this.token = getToken();
    rpc(
      'StoreCouponTemplateService.GetCouponTemplateList',
      M('CouponTemplateListQueryRequest', {
        token: M('Token', { token: this.token }),
        isdeleted: 2,
        count: 100
      })
    ).then(res => {
      this.coupontemplatelist = res.coupontemplatelistList;
    });
    rpc(
      'StoreCategoryService.GetCategoryList',
      M('CategoryListQueryRequest', {
        token: M('Token', { token: this.token }),
        ishidden: 2,
        level: 1,
        count: 100,
        sortby: 1
      })
    ).then(res => {
      this.categories = res.categorylistList;
    });
  },
  methods: {
    getProducts(name) {
      if (!name) return (this.products = []);
      this.fetchProductLoading = true;
      rpc1(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token: this.token }),
          name,
          isonline: 1,
          sortby: 1,
          sort: 1,
          count: 100
        })
      ).then(res => {
        this.products = res.productlistList;
        this.fetchProductLoading = false;
      });
    },
    chooseCoupon(row) {
      this.currentGift = row;
      this.dialogTableVisible = false;
    },

    onSubmit() {
      const row = JSON.parse(JSON.stringify(this.form));
      if (row.kind == 0) {
        row.gifttype = 0;
        row.giftid = this.currentGift.id || 0;
      }
      if (row.kind == 20) {
        row.kind = 2;
        row.gifttype = 0;
        row.giftid = this.currentGift.id || 0;
      }
      if (row.kind == 21) {
        row.kind = 2;
        row.gifttype = 1;
        row.giftid = this.currentGift.id || 0;
      }
      if (this.limittime == 1 && this.time.length === 2) {
        row.begintime = parseInt(this.time[0].getTime() / 1000);
        row.endtime = parseInt(this.time[1].getTime() / 1000);
      }
      row.reach = parseInt(row.reach * 100);
      row.reduction = parseInt(row.reduction * 100);
      rpc(
        'StoreMarketingService.CreateMarketing',
        M('MarketingWithTokenRequest', {
          token: M('Token', { token: this.token }),
          marketing: M('Marketing', row)
        })
      ).then(res => {
        this.$router.back();
      });
    }
  }
};
</script>

<style>
.marketing-type-form .el-input-group__append {
  padding: 0 5px;
}
.product-select .el-select .el-tag {
  padding-right: 8px;
}
.product-select .el-select__tags-text {
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: inline-block;
  vertical-align: middle;
  padding-bottom: 3px;
}
</style>
